/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MRecordFileCredentialsSchema } from '../models/MRecordFileCredentialsSchema';
import type { PagedMRecordListSchema } from '../models/PagedMRecordListSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MrecordsApi {
    /**
     * Create Mrecord File Credentials
     * Create file content from mrecord url
     * @returns MRecordFileCredentialsSchema OK
     * @throws ApiError
     */
    public static mrecordsCreateMrecordFileCredentialsGet({
        patientId,
        recordType,
        mRecordId,
    }: {
        patientId: number,
        recordType: 'Bederni' | 'Krcni' | 'Hrudni' | 'KoncetinyDolni' | 'KoncetinyHorni' | 'Kontrolni',
        mRecordId?: (number | null),
    }): CancelablePromise<MRecordFileCredentialsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/mrecords/mrecord/',
            query: {
                'patient_id': patientId,
                'record_type': recordType,
                'm_record_id': mRecordId,
            },
        });
    }
    /**
     * Get Mrecord File Credentials
     * Get mrecord file credentials
     * @returns MRecordFileCredentialsSchema OK
     * @throws ApiError
     */
    public static mrecordsGetMrecordFileCredentialsGet({
        mrecordId,
    }: {
        mrecordId: number,
    }): CancelablePromise<MRecordFileCredentialsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/mrecords/{mrecord_id}/',
            path: {
                'mrecord_id': mrecordId,
            },
        });
    }
    /**
     * Get Mrecords For Patient
     * get mrecords for patient
     * @returns PagedMRecordListSchema OK
     * @throws ApiError
     */
    public static mrecordsGetMrecordsForPatientGet({
        patientId,
        sync = false,
        limit = 100,
        offset,
    }: {
        patientId: string,
        sync?: boolean,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedMRecordListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/mrecords/patient/{patient_id}/',
            path: {
                'patient_id': patientId,
            },
            query: {
                'sync': sync,
                'limit': limit,
                'offset': offset,
            },
        });
    }
}
